<template>
  <div class="q-pa-md">
    <div class="row justify-end q-mb-sm">
      <q-btn
        label="Exportar"
        color="secondary"
        icon="file_upload"
        @click="exportar"
        no-caps
      />
    </div>
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="rows"
      :columns="columns"
      :loading="disable"
      row-key="name"
      class="tabela-tamanho-fixo"
      dense
      v-model:pagination="pagination"
      hide-pagination
      @request="handleRequest"
    >
      <template #body-cell-uuid="props">
        <q-td>
          <router-link
            :to="{
              name: 'detalheTransferencia',
              params: { id: props.row.uuid },
            }"
          >
            <q-btn size="sm" round color="blue-6" icon="add" />
          </router-link>
        </q-td>
      </template>

      <template #body-cell-unidadeOrigem="props">
        <q-td>
          {{ props.row.unidadeOrigem.unidade.nome }}
        </q-td>
      </template>
      <template #body-cell-numero="props">
        <q-td>
          {{ props.row.numero }}
        </q-td>
      </template>
      <template #body-cell-unidadeDestino="props">
        <q-td>
          {{ props.row.unidadeDestino.unidade.nome }}
        </q-td>
      </template>
      <template #body-cell-almox="props">
        <q-td v-if="props.row.almox">
          {{ props.row.almox.nome }}
        </q-td>
        <q-td v-else> Sem almox </q-td>
      </template>

      <template #body-cell-status="props">
        <q-td>
          <div
            :style="
              props.row.status == 'recebida'
                ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                : props.row.status == 'criada'
                ? 'width: fit-content; background:  #7CB3F7; padding: 2px 5px;'
                : props.row.status == 'enviada'
                ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                : props.row.status == 'cancelada'
                ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                : props.row.status == 'recebida_parcialmente'
                ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                : props.row.status == 'rejeitada'
                ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                : props.row.status == 'deletada'
                ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                : ''
            "
            class="row col-12 no-wrap align items-center"
          >
            <span
              v-if="props.row.status == 'recebida'"
              class="elipse q-mr-sm bg-positive"
            ></span>
            <span
              v-if="props.row.status == 'criada'"
              class="elipse q-mr-sm"
              style="background: #473fe8"
            ></span>
            <span
              v-if="props.row.status == 'enviada'"
              class="elipse q-mr-sm bg-warning"
            ></span>
            <span
              v-if="props.row.status == 'cancelada'"
              class="elipse q-mr-sm"
              style="background: #b0cde8"
            ></span>
            <span
              v-if="props.row.status == 'recebida_parcialmente'"
              class="elipse q-mr-sm"
              style="background: #fa9726"
            ></span>
            <span
              v-if="props.row.status == 'rejeitada'"
              class="elipse q-mr-sm"
              style="background: #6b1215"
            ></span>
            <span
              v-if="props.row.status == 'deletada'"
              class="elipse q-mr-sm"
              style="background: #b0cde8"
            ></span>
            <div
              v-if="props.row.status == 'recebida'"
              style="width: fit-content; background: #e8ffec"
              class="text-brand-5 text-bold"
            >
              {{ "Recebida" }}
            </div>
            <div
              v-if="props.row.status == 'criada'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Criada" }}
            </div>
            <div
              v-if="props.row.status == 'enviada'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Enviada" }}
            </div>
            <div
              v-if="props.row.status == 'cancelada'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Cancelada" }}
            </div>
            <div
              v-if="props.row.status == 'recebida_parcialmente'"
              style="width: fit-content"
              class="text-bold"
            >
              {{ "Recebida Parcialmente" }}
            </div>
            <div
              v-if="props.row.status == 'rejeitada'"
              style="width: fit-content"
              class="text-bold text-white"
            >
              {{ "Rejeitada" }}
            </div>
          </div>
        </q-td>
      </template>
      <template #body-cell-solicitante="props">
        <q-td v-if="props.row.solicitante">
          {{ props.row.solicitante.nome }}
        </q-td>
        <q-td v-else>
          <p>Sem solicitante</p>
        </q-td>
      </template>
      <template #body-cell-criada="props">
        <q-td>
          {{
            props.row.marcoTemporal.createdAt
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("/")
          }}
          {{ props.row.marcoTemporal.createdAt.split(" ")[1] }}
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "uuid",
    label: "Detalhes",
    field: "uuid",
    align: "left",
  },
  {
    name: "unidadeOrigem",
    label: "Origem",
    field: "unidadeOrigem",
    align: "left",
  },
  {
    name: "numero",
    label: "Numero Transferencia",
    field: "numero",
    align: "left",
  },
  {
    name: "unidadeDestino",
    label: "Destino",
    field: "unidadeDestino",
    align: "left",
  },
  {
    name: "almox",
    label: "Operação",
    field: "almox",
    align: "left",
  },
  {
    name: "status",
    label: "Status Atual",
    field: "status",
    align: "left",
  },
  {
    name: "solicitante",
    label: "Solicitante",
    field: "solicitante",
    align: "left",
  },
  {
    name: "criada",
    label: "Criada",
    field: "criada",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";
export default {
  props: ["filtros", "atualizar"],
  setup(props) {
    const router = useRouter();
    const $q = useQuasar();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(true);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getCriadas = async (page = 0, rowsPerPage = 6) => {
      let response = await store.dispatch("fer/listarTransferenciasCriada", {
        status: props.filtros.status,
        origem_id: props.filtros.origem,
        destino_id: props.filtros.destino,
        data_inicial: props.filtros.dataInicial,
        data_final: props.filtros.dataFinal,
        numero: props.filtros.numero,
        per_page: rowsPerPage,
        current_page: page,
        patrimonio: props.filtros.patrimonio,
      });

      rows.value = response.data.data;
      pagination.value.rowsPerPage = response.data.per_page;
      pagination.value.rowsNumber = response.data.total;
      // pagination.value.page = response.data.current_page;

      disable.value = false;
    };

    onMounted(getCriadas);

    const detalhe = async (value) => {
      router.push({ name: "detalheTransferencia", params: { id: value } });
    };

    watch(props.atualizar, () => {
      getCriadas();
    });

    const handleRequest = async () => {
      getCriadas(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    const exportar = async (page = 0, rowsPerPage = 15) => {
      try {
        await store.dispatch("fer/listarTransferenciasCriadaExportar", {
          status: props.filtros.status,
          origem_id: props.filtros.origem,
          destino_id: props.filtros.destino,
          data_inicial: props.filtros.dataInicial,
          data_final: props.filtros.dataFinal,
          numero: props.filtros.numero,
          per_page: rowsPerPage,
          current_page: page,
        });

        $q.notify({
          message:
            "Dados Exportados com sucesso, chegara a seu e-mail em breve o link",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao Exportar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      columns,
      rows,
      detalhe,
      getCriadas,
      pagination,
      handleRequest,
      exportar,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.elipse {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
